module.exports = __webpack_public_path__ + "static/img/11_4Archive_18a_Kaprow_scriptPPdetailed_2.d0abb67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_18a_Kaprow_scriptPPdetailed_2.jpg
// module id = rLAG
// module chunks = 0